import {DocSpeciality} from '@drl/shared/utility/patients-caregiver-utility.enum';
import {PrescriptionMedicines} from './prescription-medicines.model';

export class Prescriptions {
  id?: number;
  externalId: string;
  prescriptionDate: Date;
  startDate?: Date;
  endDate?: Date;
  duration?: number;
  instructions?: string;
  patientId: number;
  appointmentId?: number;
  doctorName?: string;
  doctorSpeciality?: DocSpeciality;
  medicines?: PrescriptionMedicines[];
  isActive?: boolean;
  type?: string; //display logic
  style?: string; //display logic
}
